@if (hasMessages) {
  <mat-card
    class="card">
    <mat-card-content>
      @for (message of messages; track message.id) {
        <div
          class="message">
          <mat-card-title>{{message.title}}</mat-card-title>
          <div [innerHTML]="message.sanitizedBody"
            class="message-body">
          </div>
        </div>
      }
    </mat-card-content>
  </mat-card>
}
